/**
 * 请求工具模块
 * 基于 httpClient 封装统一的请求方法
 */

import { httpClient } from '../services/httpClient';

// 请求配置接口
export interface RequestConfig {
  url: string;
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  data?: any;
  params?: any;
  headers?: Record<string, string>;
  responseType?: 'json' | 'blob' | 'arraybuffer' | 'text';
  timeout?: number;
}

// 请求响应接口
export interface RequestResponse<T = any> {
  code: number;
  message: string;
  data: T;
  timestamp: number;
}

/**
 * 统一的请求方法
 */
const request = async <T = any>(config: RequestConfig): Promise<RequestResponse<T>> => {
  const { url, method = 'GET', data, params, headers, responseType = 'json', timeout } = config;

  try {
    let response;
    
    // 构建请求配置
    const requestConfig: any = { headers };
    if (timeout) {
      requestConfig.timeout = timeout;
    }
    
    // 对于blob类型，设置responseType
    if (responseType === 'blob') {
      requestConfig.responseType = 'blob';
    }

    switch (method.toUpperCase()) {
      case 'GET':
        response = await httpClient.get<T>(url, { params, ...requestConfig });
        break;
      case 'POST':
        response = await httpClient.post<T>(url, data, requestConfig);
        break;
      case 'PUT':
        response = await httpClient.put<T>(url, data, requestConfig);
        break;
      case 'DELETE':
        response = await httpClient.delete<T>(url, { params, ...requestConfig });
        break;
      case 'PATCH':
        response = await httpClient.patch<T>(url, data, requestConfig);
        break;
      default:
        throw new Error(`不支持的请求方法: ${method}`);
    }

    return response;
  } catch (error) {
    console.error('请求失败:', error);
    throw error;
  }
};

export default request;
